module.exports = __webpack_public_path__ + "img/industry4.c2737719.png";